<template>
  <ul class="review_content_list">
    <li>
      <p>
        <span class="reviewer_id">{{ review.writerMemberId }}</span>
        <span v-if="review.writeDate" class="reviewer_date">{{
          review.writeDate | date
        }}</span>
        <span class="review_score_area">
          <star-rating
            class="star-rating"
            :rating="review.score"
            active-color="#FBE116"
            :star-size="starSize"
            :increment="increment"
            :show-rating="showRating"
            :read-only="readOnly"
          />
        </span>
        <span
          v-if="$route.path.includes({ path: 'note' })"
          class="reviewer_meta_state"
          :class="{ active: review.buyYn === 'Y' }"
        >
          <!-- <span v-if="review.shared == true"> 공유</span>
          <span v-if="review.shared == false">{{ $t('library.reviewitem.2199') }}</span> -->
          <span> {{ review.buyYn ? '구매' : '비구매' }}</span>
          <span v-if="review.purchased === false">{{
            $t('library.reviewitem.2745')
          }}</span>
        </span>

        <span
          tabindex="0"
          class="reviewer_meta_good"
          :class="{ active: voted === 'good' }"
          @click="upVote"
          @keypress.enter="upVote"
          ><span class="blind">{{ $t('library.reviewitem.good') }}</span
          ><em>{{ review.evalGood || 0 }}</em></span
        >
        <span
          tabindex="0"
          class="reviewer_meta_bad"
          :class="{ active: voted === 'bad' }"
          @click="downVote"
          @keypress.enter="downVote"
          ><span class="blind">{{ $t('library.reviewitem.bad') }}</span
          ><em>{{ review.evalBad || 0 }}</em></span
        >
      </p>
      <p v-if="!editing" class="reviewer_comment">
        <span class="visible">
          {{ review.review }}
        </span>
      </p>
      <!-- Review Modyfiy -->
      <div v-if="editing" class="reviewer_comment_modyfiy">
        <form class="review_input_form">
          <textarea
            v-model="updatedReview.review"
            class="review_input_t"
            name="modify"
            style="height: 332px;"
            :placeholder="$t('library.reviewitem.4916')"
            maxlength="500"
          />

          <div class="review_bottom_wrap">
            <div class="review_score_box">
              <span class="review_score_txt">{{ $t('common.ui.rating') }}</span>
              <div class="review_score_area">
                <star-rating
                  class="star-rating"
                  :rating="updatedReview.score"
                  active-color="#FBE116"
                  :star-size="starSizeEdit"
                  :increment="increment"
                  :show-rating="showRating"
                  @rating-selected="setRating"
                />
              </div>
            </div>

            <div class="review_btn_wrap">
              <button class="box_btn dull" @click="toggleEditReview">
                <span class="an_t">{{ $t('library.deletemodal.cancel') }}</span>
              </button>
            </div>

            <div class="review_btn_wrap button-spacing">
              <button class="box_btn" @click.prevent="updateReview">
                <span class="an_t">{{ $t('library.deletemodal.save') }}</span>
              </button>
            </div>
          </div>
        </form>
      </div>
      <div
        v-if="review.memberId === getCurrentUser.loginId && !editing"
        class="reviewer_modify"
      >
        <button class="modify an_a" @click="toggleEditReview">
          <span class="c_icon"></span
          ><span class="an_t">{{ $t('library.reviewitem.edit') }}</span>
        </button>
        <button class="delete an_a" @click="deleteReview">
          <span class="c_icon"></span
          ><span class="an_t">{{ $t('library.reviewitem.delete') }}</span>
        </button>
      </div>
    </li>
  </ul>
</template>

<script>
import StarRating from 'vue-star-rating'

import { mapGetters } from 'vuex'

import {
  ACCOUNT_REVIEW_UPDATE,
  ACCOUNT_REVIEW_DELETE,
  ACCOUNT_REVIEW_VOTE
} from '@/store/types'

export default {
  name: 'ReviewItem',
  components: {
    StarRating
  },

  props: {
    review: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      editing: false,
      voted: '',
      // For star-rating package
      starSize: 15,
      starSizeEdit: 28,
      increment: 0.5,
      showRating: false,
      readOnly: true,
      updatedReview: {},
      error: null
    }
  },
  computed: {
    ...mapGetters(['getCurrentUser', 'getStoreCurrentBook'])
  },
  watch: {
    review() {
      this.setDefaultUpdatedReview()
    }
  },
  mounted() {
    this.setDefaultUpdatedReview()
  },

  methods: {
    async upVote() {
      this.voted = 'good'
      const evalTp = 'G'
      const reviewId = this.review.reviewSeq
      const bookId = this.getStoreCurrentBook.id

      try {
        await this.$store.dispatch(ACCOUNT_REVIEW_VOTE, {
          reviewId,
          bookId,
          evalTp
        })
        this.$emit('reload')
      } catch (err) {
        this.error = err
      }
    },
    async downVote() {
      this.voted = 'bad'
      const evalTp = 'B'
      const reviewId = this.review.reviewSeq
      const bookId = this.getStoreCurrentBook.id

      try {
        await this.$store.dispatch(ACCOUNT_REVIEW_VOTE, {
          reviewId,
          bookId,
          evalTp
        })
        this.$emit('reload')
      } catch (err) {
        this.error = err
      }
    },
    async updateReview() {
      const review = {
        ...this.updatedReview,
        bookCd: this.getStoreCurrentBook.id
      }
      try {
        await this.$store.dispatch(ACCOUNT_REVIEW_UPDATE, review)
        this.toggleEditReview()
        this.$emit('reload')
      } catch (err) {
        this.error = err
      }
    },
    toggleEditReview() {
      this.editing = !this.editing

      if (!this.editing) {
        this.setDefaultUpdatedReview()
      }
    },
    async deleteReview() {
      const { id } = this.getStoreCurrentBook
      const review = { bookCd: id }

      try {
        await this.$store.dispatch(ACCOUNT_REVIEW_DELETE, review)
        this.$emit('reload')
      } catch (err) {
        this.error = err
      }
    },
    setDefaultUpdatedReview() {
      this.updatedReview.review = this.review.review
      this.updatedReview.score = this.review.score
    },
    setRating(rating) {
      this.updatedReview.score = rating
    }
  }
}
</script>

<style lang="scss" scoped>
.reviewer_meta_good,
.reviewer_meta_bad {
  cursor: pointer;
}

.button-spacing {
  margin-left: 15px;
}
</style>
